import script from "./ClassesListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClassesListPage.vue?vue&type=script&lang=ts&setup=true"

import "./ClassesListPage.vue?vue&type=style&index=0&id=b7e56a2e&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e56a2e"]])

export default __exports__